/**
 * One person on one finishing task for one unbroken stretch of time. A lead
 * drags people onto tasks at the finishing kiosk; every drag closes the
 * person's open session and opens a new one, so the rows are an append-only
 * record of who worked on what, when.
 *
 * Labor minutes per part for a task = the sum of its sessions' durations over
 * the parts finished, so two people for 30 minutes count as 60 without a
 * crew-size field. The quantities frozen at the start and end of each session
 * let a run that spans several sessions (or shifts) be split by what each one
 * actually finished.
 */
export interface PlasticsFinishingLaborSession {
    id: string;
    /** the org chart employee - most floor staff have no Prism login */
    employeeId: string;
    finishingTaskId: string;
    finishingStationId: string;
    /** what the task was for, frozen when the session opened */
    orderedProductId: string;
    productId: string;
    /** the product's released version when the session opened - the recipe the time was spent on */
    productVersionId: string;
    /** true until the session is closed - the kiosk listens for open sessions only */
    isOpen: boolean;
    startedOn: Date;
    endedOn: Date | null;
    /** the Prism user signed in at the kiosk when the session opened / closed */
    startedById: string;
    endedById: string;
    endReason: PlasticsFinishingLaborSessionEndReason | null;
    /** the task's completed quantity when the session opened / closed */
    quantityAtStart: number;
    quantityAtEnd: number | null;
}

export enum PlasticsFinishingLaborSessionEndReason {
    /** dragged onto another task */
    Moved = 'moved',
    /** dragged back to the crew bar */
    Removed = 'removed',
    /** the task was completed */
    TaskCompleted = 'task-completed',
    /** the task was taken off the active workbench */
    TaskInactive = 'task-inactive',
    /** still open after the person's shift ended - closed at the shift's end, not when anyone noticed */
    AutoClosed = 'auto-closed',
}
